import { z } from "zod";

export const rsvpSchema = z
  .object({
    fullName: z.string().min(2, "Please enter your full name"),
    email: z.string().email("Please provide a valid email"),
    attendance: z.enum(["yes", "no"]),
    guestCount: z.coerce.number().int().min(1).max(2).optional(),
    dietaryNotes: z.string().max(200).optional(),
    message: z.string().max(400).optional(),
  })
  .superRefine((value, ctx) => {
    if (value.attendance === "yes" && !value.guestCount) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["guestCount"],
        message: "Please select number of guests",
      });
    }
  });

export type RsvpFormValues = z.infer<typeof rsvpSchema>;
